import { MS_LOG_IN_API } from '../../constants/api';
import axios from '../fetch/fetch';

export const msLoginAPI = async (authorizationCode: string): Promise<any> => {
    const body = {
        authorizationCode,
    };
    const res = await axios.post(MS_LOG_IN_API, body, { headers: { 'Access-Control-Allow-Origin': '*' } });
    return res.data;
};
